import { render, staticRenderFns } from "./DownloadsTab.vue?vue&type=template&id=8a4249b8&"
import script from "./DownloadsTab.vue?vue&type=script&lang=js&"
export * from "./DownloadsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports